import type { PostFeedbackFeaturedAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import PostFeedbackQ from './PostFeedbackQ'

const PostFeedbackFeaturedQ = {
  ...makeQueryModelV2<PostFeedbackFeaturedAttributes>('post_feedback_featured')([
    'id',
    'post_feedback_id',
    'user_id',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    PostFeedback: {
      query: PostFeedbackQ,
      foreignKey: PostFeedbackQ.id,
      sourceKey: PostFeedbackFeaturedQ.post_feedback_id,
    },
  }),

  where: (
    {
      postFeedbackId,
      paranoid = true,
      userId,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      postFeedbackId?: number | null | SQLFragment<number>
      paranoid?: boolean
      userId?: number | null | SQLFragment<number>
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<PostFeedbackFeaturedAttributes> => SQL`
        FROM ${PostFeedbackFeaturedQ}
        ${includeAssociationsToSql(PostFeedbackFeaturedQ, include)}
        WHERE
            ${
              postFeedbackId != null
                ? SQL`${PostFeedbackFeaturedQ.post_feedback_id} = ${postFeedbackId} AND`
                : SQL``
            }
            ${userId != null ? SQL`${PostFeedbackFeaturedQ.user_id} = ${userId} AND` : SQL``}
            ${paranoid ? SQL`${PostFeedbackFeaturedQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default PostFeedbackFeaturedQ
